import { render, staticRenderFns } from "./izlemetablosuaylik.vue?vue&type=template&id=e5617084"
import script from "./izlemetablosuaylik.vue?vue&type=script&lang=js"
export * from "./izlemetablosuaylik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports